export default __webpack_public_path__ + "static/media/i103jp.18f30e50.webp";